import { Switch } from '../ui/switch';
import { vibrate } from '../../lib/bus';

const color = (f) => (f >= 45 ? '#34d399' : f >= 25 ? '#fde047' : '#fb7185');

function Spark({ data }) {
  const max = Math.max(60, ...data);
  const pts = data.map((v, i) => `${(i / Math.max(1, data.length - 1)) * 100},${40 - (v / max) * 38}`).join(' ');
  return (
    <svg viewBox="0 0 100 40" preserveAspectRatio="none" className="w-full h-16">
      <line x1="0" x2="100" y1={40 - (45 / max) * 38} y2={40 - (45 / max) * 38} stroke="#fde04733" strokeDasharray="2 2" />
      <polyline points={pts} fill="none" stroke={color(data[data.length - 1] || 0)} strokeWidth="1.2" vectorEffect="non-scaling-stroke" />
    </svg>
  );
}

export default function MonitorPanel({ stats, settings, updateSettings }) {
  return (
    <div data-testid="monitor-panel" className="space-y-5">
      <div className="t-label">Performance & Debug Monitor</div>
      <div className="rounded-xl border border-white/10 bg-black/30 p-4">
        <div className="flex items-end gap-2">
          <span data-testid="monitor-fps" className="text-5xl font-extrabold tabular-nums" style={{ color: color(stats.fps), textShadow: `0 0 24px ${color(stats.fps)}66` }}>{stats.fps}</span>
          <span className="text-xs text-slate-400 mb-2">FPS · target {settings.fps}</span>
        </div>
        <Spark data={stats.hist.length ? stats.hist : [0]} />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="rounded-xl border border-white/10 p-3"><div className="t-label">RAM stimata</div><div data-testid="monitor-mem" className="text-xl font-bold text-violet-300 mt-1">{stats.mem != null ? `${stats.mem} MB` : 'n/d'}</div></div>
        <div className="rounded-xl border border-white/10 p-3"><div className="t-label">Entità attive</div><div data-testid="monitor-entities" className="text-xl font-bold text-cyan-300 mt-1">{stats.entities}</div></div>
      </div>
      <div>
        <div className="t-label mb-2">Frame limiter (risparmio batteria)</div>
        <div className="grid grid-cols-3 gap-2">
          {[30, 60, 120].map((f) => (
            <button key={f} data-testid={`fps-target-${f}`} onClick={() => updateSettings({ fps: f })}
              className={`rounded-lg py-2 text-xs font-bold border transition-colors ${settings.fps === f ? 'bg-violet-600/50 border-violet-400 text-white' : 'border-white/10 text-slate-400 hover:bg-white/5'}`}>{f} FPS</button>
          ))}
        </div>
      </div>
      <div className="rounded-xl border border-white/10 p-3 space-y-3">
        <div className="flex items-center justify-between"><span className="text-xs text-slate-300">Vibrazione aptica</span><Switch data-testid="haptics-toggle" checked={settings.haptics} onCheckedChange={(v) => updateSettings({ haptics: v })} /></div>
        <div className="grid grid-cols-3 gap-1.5">
          {[['Tocco', 12], ['Collisione', [35, 45, 35]], ['Esplosione', [220, 60, 420]]].map(([l, p]) => (
            <button key={l} data-testid={`haptic-test-${l.toLowerCase()}`} onClick={() => vibrate(p, settings.haptics)} className="rounded-lg border border-white/10 py-1.5 text-[10px] text-slate-300 hover:bg-white/5">{l}</button>
          ))}
        </div>
      </div>
    </div>
  );
}
